import '@stoplight/elements/styles.min.css';

import { subscribeTheme } from '@stoplight/mosaic';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { App } from './App';

// Disable non-critical console output in production builds
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // Silence common logging methods to avoid noisy deprecation notices, etc.
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}

subscribeTheme();

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
